<template>
  <v-card>
    <v-card-title>change Password</v-card-title>
    <v-card-text>
      <div class="reset-email-code">
        <v-text-field
          prepend-icon="email"
          label="Email"
          type="text"
          v-model="data.email"
          :disabled='true'
        ></v-text-field>
      </div>
      <div class="reset-email-code">
        <v-text-field
          prepend-icon="delete_sweep"
          label="Old Password"
          type="password"
          v-model="data.oldPassword"
        ></v-text-field>
      </div>
      <div class="reset-email-code">
        <v-text-field
          prepend-icon="arrow_forward"
          label="New Password"
          type="password"
          :rules="[rules.min]"
          v-model="data.newPassword"
        ></v-text-field>
      </div>
      <div class="reset-email-code">
        <v-text-field
          prepend-icon="arrow_forward"
          label="Please enter again"
          type="password"
          v-model="data.ensurePassword"
        ></v-text-field>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="changePassword" :disabled="saveDisable">
        Save
      </v-btn>
      <v-btn color="blue darken-1" text @click="hideDialog">
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { AuthApi } from '@/api/pandaria'
import { Cache, Crypto, Tool, Popup } from '@/util/index'

const cache = new Cache()
const tool = new Tool()
const popup = new Popup()
export default {
  name: 'change-pass-card',
  data () {
    return {
      data: {
        email: '',
        oldPassword: '',
        newPassword: '',
        ensurePassword: ''
      },
      saveDisable: true,
      rules: {
        min: function (value) {
          const regex = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,18}$')
          if (value.length < 8) {
            return 'Min 8 characters'
          } else if (value.length > 18) {
            return 'Max 18 characters'
          } else if (!regex.test(value) && value.length >= 8 && value.length <= 18) {
            return 'The password must contain uppercase letters, lowercase letters, numbers, special characters'
          } else {
            return true
          }
        }
      },
      compareText: ''
    }
  },
  watch: {
    data: {
      handler: function () {
        this.saveDisable = !(tool.isNotEmpty(this.data.oldPassword) && tool.isNotEmpty(this.data.newPassword) && tool.isNotEmpty(this.data.ensurePassword) && this.rules.min(this.data.newPassword))
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    this.data.email = this.store.getters.getAccount.email
  },
  methods: {
    hideDialog () {
      this.data.oldPassword = ''
      this.data.newPassword = ''
      this.data.ensurePassword = ''
      this.saveDisable = true
      this.$emit('hideDialog')
    },
    changePassword () {
      const $this = this
      this.saveDisable = true
      if (this.data.newPassword !== this.data.ensurePassword) {
        popup.popupForWarning('The two passwords you typed do not match.')
      } else {
        const changePassword = {
          email: this.store.getters.getAccount.email,
          oldPassword: Crypto.md5(this.data.oldPassword),
          newPassword: Crypto.md5(this.data.newPassword),
          token: cache.getAccessToken()
        }
        AuthApi.changePassword(changePassword, function (result) {
          popup.popupForSuccess('Success to change password.Please log in again', function () {
            cache.clearSignInData()
            $this.$router.replace({ path: '/sign-in' })
          })
        }, function (result) {
          $this.saveDisable = false
          popup.popupForWarning(result.message)
        })
      }
    }
  }
}
</script>

<style scoped lang="css">
  .reset-email-code {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .reset-email-code button {
    margin: 0 10px;
    width: 20%;
  }
  .reset-email-code {
    width: 100%!important;
  }

</style>
